module.exports = __webpack_public_path__ + "img/logo-perki.b683fb4b.png";